import CloseButton from './CloseButton'
import FaqButton from './FaqButton'
import SettingsButton from './SettingsButton'
import BackButton from './BackButton'
import Button from './Button'

export {CloseButton, FaqButton, SettingsButton, BackButton, Button}



// WEBPACK FOOTER //
// ./components/Buttons/index.js